import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'join' })
export class JoinPipe implements PipeTransform {
  transform(input: any[] | null | undefined, separator = ', '): string {
    return input?.filter(x => x).join(separator) || '';
  }
}
